export enum UnknownEnum {
  Unknown = 'UNKNOWN'
};